import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type MemberDownloads } from "./types";

const reducer = (
  state: MemberDownloads.AppState = defaultState,
  action: ReduxAction<any>
): MemberDownloads.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { items } = action.data as InitSuccessActionData;
      return {
        ...state,
        items,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: MemberDownloads.AppState = {
  error: null,
  id: "",
  status: Status.None,
  items: []
};
export const previewState: MemberDownloads.AppState = {
  ...defaultState,
  status: Status.Ready,
  items: []
};
export default wrapReducer({ defaultState, reducer, previewState });
